import type { UnifiedConfigTableProps } from './utils/configTypes'
import { ConfigTable } from './components/ConfigTable'

// Create a simple UI that unifies the three configuration types
export function UnifiedConfigTable({ form, onFormChange }: UnifiedConfigTableProps) {
  return <ConfigTable form={form} onFormChange={onFormChange} />
}
